import {isNotNil} from 'ramda';

import {VehicleFinancingTemplateResponseBody} from '@dms/api/sales';

import {deserializeRateMatrix} from '../../RateMatrix/utils/deserializeRateMatrix';
import {VehicleFinancingTemplateFormValues} from '../vehicleFinancingTemplateFormSchema';
import {moneyToNumber} from './moneyToNumber';

export function mapResponseToFormValues(
  template: VehicleFinancingTemplateResponseBody
): VehicleFinancingTemplateFormValues {
  return {
    name: template.name,
    type: [template.type],
    // A stored template is a campaign as soon as either boundary is set; everything else opens in
    // the unlimited editor.
    validityMode:
      isNotNil(template.validFrom) || isNotNil(template.validTo) ? 'PERIOD' : 'UNLIMITED',
    validFrom: template.validFrom,
    validTo: template.validTo,
    expirationAction: template.expirationAction,
    replacementTemplateId: template.replacementTemplateId,
    interestRateType: isNotNil(template.interestRateType) ? [template.interestRateType] : [],
    downPaymentStep: [template.downPaymentStep],
    balloonPaymentStep: isNotNil(template.balloonPaymentStep) ? [template.balloonPaymentStep] : [],
    financialInstitutionCodeId: template.financialInstitutionCodeId,
    processingFee: moneyToNumber(template.processingFee),
    vehicleTransferIncluded: template.vehicleTransferIncluded,
    vehicleTransferAmount: moneyToNumber(template.vehicleTransferAmount),
    vehicleRegistrationIncluded: template.vehicleRegistrationIncluded,
    vehicleRegistrationAmount: moneyToNumber(template.vehicleRegistrationAmount),
    vehicleDeliveryIncluded: template.vehicleDeliveryIncluded,
    vehicleDeliveryAmount: moneyToNumber(template.vehicleDeliveryAmount),
    tradeInPossible: template.tradeInPossible,
    creditProtectionAutoEnable: template.creditProtectionAutoEnable,
    scope: {
      mode: template.scope.mode,
      branchIds: template.scope.branchIds,
      segment: {
        makes: template.scope.segment.makes,
        models: template.scope.segment.models,
        vehicleCategories: template.scope.segment.vehicleCategories,
        fuelTypes: template.scope.segment.fuelTypes,
        yearFrom: template.scope.segment.yearFrom,
        yearTo: template.scope.segment.yearTo,
        mileageFrom: template.scope.segment.mileageFrom,
        mileageTo: template.scope.segment.mileageTo,
        sellingPriceFrom: moneyToNumber(template.scope.segment.sellingPriceFrom),
        sellingPriceTo: moneyToNumber(template.scope.segment.sellingPriceTo),
      },
    },
    rateMatrix: deserializeRateMatrix(template.rateMatrix, template.defaultBalloonPayment),
  };
}
